import { isValidElement, createElement } from 'react';
import { isfunc, buildName, withApi, withAll, withRootExtension, } from 'piral-core';
import { createActions } from './actions';
import { DefaultContainer, DefaultInput, DefaultResult } from './default';
import { Search } from './Search';
import { SearchInput } from './SearchInput';
function noop() { }
function createSearchRegistration(pilet, search, settings = {}) {
    const { onlyImmediate = false, onCancel = noop, onClear = noop, ...rest } = settings;
    return {
        ...rest,
        pilet,
        onlyImmediate,
        cancel: isfunc(onCancel) ? onCancel : noop,
        clear: isfunc(onClear) ? onClear : noop,
        search,
    };
}
function getSearchProviders(providers) {
    const searchProviders = {};
    let i = 0;
    for (const { search, settings } of providers) {
        searchProviders[`global-${i++}`] = createSearchRegistration(undefined, search, settings);
    }
    return searchProviders;
}
function toChild(content, api, context) {
    if (typeof content === 'string' || isValidElement(content)) {
        return content;
    }
    else {
        const component = withApi(context, content, api, 'extension');
        return createElement(component);
    }
}
function wrapResults(result, api, context) {
    const results = Array.isArray(result) ? result : [result];
    return results.map((item) => toChild(item, api, context));
}
function withSearch(searchProviders, query, items) {
    return (state) => ({
        ...state,
        components: {
            SearchContainer: DefaultContainer,
            SearchInput: DefaultInput,
            SearchResult: DefaultResult,
            ...state.components,
        },
        registry: {
            ...state.registry,
            searchProviders,
        },
        search: {
            input: query,
            results: {
                loading: false,
                items,
            },
        },
    });
}
/**
 * Creates new Pilet API extensions for search and filtering.
 */
export function createSearchApi(config = {}) {
    const { providers = [], results = [], query = '', ...actionConfig } = config;
    return (context) => {
        context.defineActions(createActions(actionConfig));
        context.dispatch(withAll(withSearch(getSearchProviders(providers), query, results), withRootExtension('piral-search', Search), withRootExtension('piral-search-input', SearchInput)));
        return (api, target) => {
            const pilet = target.name;
            let next = 0;
            return {
                registerSearchProvider(name, provider, settings) {
                    if (typeof name !== 'string') {
                        settings = provider;
                        provider = name;
                        name = next++;
                    }
                    const id = buildName(pilet, name);
                    context.registerSearchProvider(id, createSearchRegistration(pilet, (q) => Promise.resolve(provider(q, api)).then((results) => wrapResults(results, api, context), () => []), settings));
                    return () => api.unregisterSearchProvider(name);
                },
                unregisterSearchProvider(name) {
                    const id = buildName(pilet, name);
                    context.unregisterSearchProvider(id);
                },
            };
        };
    };
}
//# sourceMappingURL=create.js.map